import _asyncToGenerator from "F:/Lee/Desktop/0206/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "F:/Lee/Desktop/0206/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import clickoutside from "@/utils/clickoutside.js";
import { getProductSeries, getproductcatelist } from "@/http/api.js";
import { mapState } from "vuex";
export default {
  directives: {
    clickoutside: clickoutside
  },
  data: function data() {
    return {
      isShowTabs: false,
      isPopoverShow: false,
      popupAboutShow: false,
      popupProductShow: false,
      tabs: [{
        id: "1",
        text: "首页",
        isActive: true,
        path: "/home",
        pageNum: 1
      }, {
        id: "2",
        text: "系列产品",
        isActive: false,
        phoneShowChildren: false,
        pageNum: 0
      }, {
        id: "3",
        text: "关于我们",
        isActive: false,
        phoneShowChildren: false,
        pageNum: 2,
        // path: "/about",
        children: [{
          id: "1",
          text: "公司新闻"
        }, {
          id: "2",
          text: "行业动态"
        }, {
          id: "4",
          text: "公司介绍"
        }, {
          id: "3",
          text: "联系我们"
        }]
      }, {
        id: "4",
        text: "硬件设备",
        isActive: false,
        path: "/hardware_device",
        pageNum: 99
      }, {
        id: "5",
        text: "授权查询",
        isActive: false,
        path: "/auth_inquire",
        pageNum: 3
      }, // {
      //   id: "6",
      //   text: "案例中心",
      //   isActive: false,
      //   path: "/case_list",
      //   pageNum: 4,
      // },
      // {
      //   id: "7",
      //   text: "合作加盟",
      //   isActive: false,
      //   path: "/cooperate",
      //   pageNum: 5,
      // },
      {
        id: "8",
        text: "产品文档",
        isActive: false,
        phoneShowChildren: false,
        pageNum: 6,
        children: [{
          id: "1",
          text: "最新更新"
        }, {
          id: "2",
          text: "产品操作手册"
        }],
        path: ""
      }, {
        id: "9",
        text: "联系我们",
        isActive: false,
        path: "/contactUs",
        pageNum: 7
      }, {
        id: "10",
        text: "免费申请小程序",
        isActive: false,
        path: "/contactUs"
      }, {
        id: "11",
        text: "论坛",
        isActive: false,
        path: "/contactUs"
      } // {
      //   id: "7",
      //   text: "合作加盟",
      //   isActive: false,
      //   path: "/cooperate",
      // },
      // {
      //   id: "8",
      //   text: "服务支持",
      //   isActive: false,
      //   path: "/service",
      // },
      ],
      softList: [],
      hardList: [],
      dropdownContentIsShow: false,
      dropdownContentIsShow2: false,
      screenWidth: document.body.clientWidth
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener("resize", function () {
      _this.screenWidth = document.body.clientWidth;
    });
    this.getCateList(1);
    this.getCateList(2);
  },
  watch: {
    $route: function $route() {
      this.isShowTabs = false;
    },
    isPopoverShow: function isPopoverShow(val) {
      if (val) {
        this.stopMove();
      } else {
        this.move();
      }
    },
    // 窗口宽度改变
    screenWidth: function screenWidth(n, o) {
      if (n < 800) {
        this.isPopoverShow = false;
        this.popupAboutShow = false;
        this.popupProductShow = false;
        this.isShowTabs = false;
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState(["sysinfo"])), {}, {
    aboutIcon: function aboutIcon() {
      if (this.popupAboutShow) {
        return "el-icon-arrow-up";
      } else {
        return "el-icon-arrow-down";
      }
    },
    productIcon: function productIcon() {
      if (this.popupProductShow) {
        return "el-icon-arrow-up";
      } else {
        return "el-icon-arrow-down";
      }
    }
  }),
  methods: {
    skipExternalLink: function skipExternalLink(link) {
      if (link) {
        window.open(link, "_blank");
      }
    },
    // 获取软硬件分类列表
    getCateList: function getCateList(type) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getProductSeries({
                  type: type
                });

              case 3:
                res = _context.sent;

                if (type == 1) {
                  _this2.softList = res.data || [];
                } else {
                  _this2.hardList = res.data || [];
                }

                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    get_Product_Series: function get_Product_Series() {// try {
      //   const params = {
      //     type: 1,
      //   };
      //   const res = await getproductcatelist(params);
      //   console.log(res);
      //   if (res.return_code === "SUCCESS") {
      //     this.softList = res.data;
      //   }
      // } catch (error) {}

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 处理点击旗舰店子展开部分的 外部
    shopDropdown: function shopDropdown() {
      this.dropdownContentIsShow = false;
    },
    shopDropdown2: function shopDropdown2() {
      this.dropdownContentIsShow2 = false;
    },
    // 处理点击 关于我们 和 产品文档的子选项展开部分的 外部
    itemDropdown: function itemDropdown() {
      this.popupAboutShow = false;
      this.popupProductShow = false;
    },
    showTabs: function showTabs() {
      this.isShowTabs = !this.isShowTabs;
    },
    handleTab: function handleTab(index) {
      console.log(index);
      this.tabs.forEach(function (v, i) {
        return index === i ? v.isActive = true : v.isActive = false;
      });
      this.move(); // this.isPopoverShow = false;

      if (index === 1) {
        this.isPopoverShow = !this.isPopoverShow;
        this.popupProductShow = false;
        this.popupAboutShow = false;
        return;
      } else if (index === 2) {
        this.popupAboutShow = !this.popupAboutShow;
        this.popupProductShow = false;
        this.isPopoverShow = false;
        return;
      } else if (index === 5) {
        this.popupProductShow = !this.popupProductShow;
        this.popupAboutShow = false;
        this.isPopoverShow = false;
        return;
      } else if (index === 7) {
        window.location.href = "https://xy.wunengkeji.cn/register";
        return;
      } else if (index === 8) {
        window.location.href = "http://bbs.wunengkeji.com/";
        return;
      }

      if (index !== 1) {
        this.$router.push(this.tabs[index].path);
        this.isPopoverShow = false;
        this.popupProductShow = false;
        this.popupAboutShow = false;
      }
    },
    phoneTabClick: function phoneTabClick(index) {
      if (index === 1 || index === 2 || index === 5) {
        this.tabs[index].phoneShowChildren = !this.tabs[index].phoneShowChildren;
      } else if (index === 7) {
        window.location.href = "https://xy.wunengkeji.cn/register";
        return;
      } else if (index === 8) {
        window.location.href = "http://bbs.wunengkeji.com/";
        return;
      } else {
        var path = this.tabs[index].path;
        this.$router.push(path);
      }
    },
    phoneChildrenTab: function phoneChildrenTab(index, index2) {
      if (index === 2) {
        if (index2 === 0) {
          this.$router.push("/news_list?type=news");
        } else if (index2 === 1) {
          this.$router.push("/news_list?type=dynamic");
        } else if (index2 === 2) {
          this.$router.push("/contactUs");
        } else if (index2 === 3) {
          this.$router.push("/about");
        }
      } else if (index === 5) {
        if (index2 === 0) {
          this.$router.push("/renew_list");
        } else if (index2 === 1) {
          this.$router.push("/product_manual");
        }
      }
    },
    // 处理点击  关于我们  下弹出框的子选项
    handleAboutPopupItem: function handleAboutPopupItem(num) {
      this.popupAboutShow = false;
      this.popupProductShow = false; // if (num == 3) {
      //   this.$router.push("/contactUs");
      //   return;
      // }

      if (num == 4) {
        this.$router.push("/about");
        return;
      }

      if (num == 5) {
        this.$router.push("/case_list");
        return;
      }

      if (num == 6) {
        this.$router.push("/cooperate");
        return;
      }

      var type = num == 1 ? "news" : "dynamic";
      this.$router.push("/news_list?type=".concat(type));
    },
    demo: function demo() {
      this.popupAboutShow = false;
    },
    softProductClickItem: function softProductClickItem(link) {
      this.isPopoverShow = false;
      setTimeout(function () {
        // this.$router.push(src);
        if (link) {
          location.href = link;
        }
      }, 500);
    },
    hardProductClickItem: function hardProductClickItem(hardName, id) {
      var _this3 = this;

      this.isPopoverShow = false;
      setTimeout(function () {
        _this3.$router.push("/device_list?id=".concat(id, "&name=").concat(hardName));
      }, 500);
    },
    // 处理点击  产品文档  下弹出框的子选项
    handleProductPopupItem: function handleProductPopupItem(num) {
      if (num == 1) {
        this.$router.push("/renew_list");
      } else if (num == 2) {
        this.$router.push("/product_manual");
      }

      this.popupAboutShow = false;
      this.popupProductShow = false;
    },
    // 组织页面滚动
    stopMove: function stopMove() {
      var m = function m(e) {
        e.preventDefault();
      };

      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, {
        passive: false
      }); //禁止页面滑动
    },
    // 开启页面滚动
    move: function move() {
      var m = function m(e) {
        e.preventDefault();
      };

      document.body.style.overflow = ""; //出现滚动条

      document.removeEventListener("touchmove", m, {
        passive: true
      });
    }
  }
};